import {IProduct} from "../../interfaces/IProduct";
import styled from "styled-components";
import {Table} from "react-bootstrap";
import CustomTooltip from "../CustomTooltip";
import React from "react";
import AppLink from "../AppLink";
import {getTheme} from "../../shared/themeUtils";

const AttributesSection = styled.div`
  font-size: ${getTheme("fontSizes.small")};
  .preview {
    color: ${getTheme("colors.internal")};
  }
  .attribute-title {
    font-weight: 500;
    width: 300px;
  }
  .value-entry {
    display: inline-block;
    border-right: 1px solid ${getTheme("colors.border")};
    padding: 0 ${getTheme("space.1")};
    .value-icon {
      max-width: 25px;
      margin-right: ${getTheme("space.1")};
    }
    &:last-of-type {
      border-right: none;
    }
    .attribute-link {
      color: ${getTheme("colors.link")};
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .table-head {
    border-bottom-width: 2px;
  }
`

type ProductAttributesPropsType = {
  product: IProduct
}

const ProductAttributesSection = (props: ProductAttributesPropsType) => {
  return (
    <AttributesSection>
      {props.product.attributes!=null && props.product.attributes.map((attribute, attrIndex) => {
        return (
          <Table key={`attribute-group-${attrIndex}`} responsive="sm">
            <thead>
              <tr>
                <th colSpan={2} className={"table-head"}>{attribute.text}</th>
              </tr>
            </thead>
            <tbody>
            {attribute.attributes.map((attr, attrItemIndex) => {
              return (
                <tr key={`attribute-item-${attrIndex}-${attrItemIndex}`}>
                  <td className="attribute-title">
                    <span className={attr.previewMode ? "preview" : ""}>{attr.text}</span>
                    {attr.tip!=null && (attr.tip && attr.tip.length>0) &&
                      <CustomTooltip placement={"right"}
                                     linkUrl={attr.tipUrl}
                                     title={attr.tipTitle}
                                     color={attr.previewMode ? "internal" : ""}
                                     content={attr.tip} />
                    }
                  </td>
                  <td>
                    {attr.values.map((value, valueIndex) => {
                      return (
                        <div key={`attribute-value-${attrIndex}-${attrItemIndex}-${valueIndex}`} className="value-entry">
                          {value.iconFilePath &&
                            <img src={value.iconFilePath}
                                 className="value-icon"
                                 alt={value.text}/>
                          }
                          <span className="value-text">
                            {value.link && value.link.href &&
                              <AppLink link={value.link}>
                                <span className={"attribute-link"}>{value.text}</span>
                              </AppLink>
                            }
                            {!value.link?.href &&
                              <span className={attr.previewMode ? "preview" : ""}>{value.text}</span>
                            }
                            {value.tip!=null && (value.tip && value.tip.length>0) &&
                              <CustomTooltip placement={"right"}
                                             linkUrl={value.tipUrl}
                                             title={value.tipTitle}
                                             color={attr.previewMode ? "internal" : ""}
                                             content={value.tip} />
                            }
                          </span>
                        </div>
                      )
                    })}
                  </td>
                </tr>
              )
            })}
            </tbody>
          </Table>
        )
      })}
    </AttributesSection>
  )
}

export default ProductAttributesSection;